export enum EventEventsEnum {
	EventCreated = 'event.created',
	EventParticipantsJoined = 'event.participants.joined'
}
